// Why: The views for 'Reisebereitschaft' and 'Zeitaufwand' are hidden for a single one-time event.
// Both are only relevant for multi-event formats or event series.

export const hasMultipleOrSeriesEvent = (events: { type?: string }[] | undefined): boolean => {
    if (!events) return false
    return events.length > 1 || (events.length === 1 && events[0].type === 'series')
}
